import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "road"
const RoadIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.014 2.109C6.092 1.702 6.485 1.436 6.892 1.514 7.298 1.592 7.565 1.985 7.487 2.392L3.737 21.892C3.66 22.298 3.265 22.565 2.86 22.487S2.186 22.016 2.264 21.61zM17.109 1.514C17.515 1.436 17.909 1.702 17.987 2.109L21.737 21.609C21.815 22.015 21.548 22.409 21.142 22.487 20.735 22.565 20.342 22.298 20.264 21.892L16.514 2.392C16.436 1.985 16.702 1.592 17.109 1.514M12 16.875C12.414 16.875 12.75 17.211 12.75 17.625V21.375C12.75 21.79 12.414 22.125 12 22.125S11.25 21.79 11.25 21.375V17.625C11.25 17.211 11.586 16.875 12 16.875M12 9.375C12.414 9.375 12.75 9.711 12.75 10.125V13.875C12.75 14.29 12.414 14.625 12 14.625S11.25 14.29 11.25 13.875V10.125C11.25 9.711 11.586 9.375 12 9.375M12 1.875C12.414 1.875 12.75 2.211 12.75 2.625V6.375C12.75 6.79 12.414 7.125 12 7.125S11.25 6.79 11.25 6.375V2.625C11.25 2.211 11.586 1.875 12 1.875" />
        </svg>
      }
    </span>
  )
}
export default RoadIcon
